export default __webpack_public_path__ + "static/media/vaskeplads-gamle-dage.ccd307f0.jpg";